import { WebRequest } from 'framework-ui-components';

// #region Get actions

export const dichiarazioni = studio => WebRequest.get('SetteTrenta/Tutti', { studio });

export const cercaDichiarazioni = params => WebRequest.get('SetteTrenta/CercaSetteTrenta', params);

export const statiSetteTrenta = (studio, searchTerm, anno) => WebRequest.get('SetteTrenta/StatiSetteTrenta', { studio, searchTerm, anno });

export const isAbilitatoImportXmlAnnoCorrente = (studio, anno) => WebRequest.get('SetteTrenta/IsAbilitatoImportXmlAnnoCorrente', { studio, anno });

export const soscaf = (studio, anno) => WebRequest.get('SetteTrenta/Soscaf', { studio, anno });

export const impostazioniServizioSetteTrenta = anno => WebRequest.get('SetteTrenta/ImpostazioniServizioSetteTrenta', { anno });

export const esisteDichiarazionePerAnagrafica = (codiceFiscale, codiceUfficio, tipoDichiarazione, anno) => WebRequest.get('SetteTrenta/EsisteDichiarazionePerAnagrafica', {
  codiceFiscale, codiceUfficio, tipoDichiarazione, anno,
});

export const preferenzeStampa = (idUtente, anno) => WebRequest.get('SetteTrenta/PreferenzeStampa', { idUtente, anno });

export const erratiCodiciFiscaliDichiarazione = (idDichiarazioneDichiarante, idDichiarazioneConiuge, anno) => WebRequest.get('SetteTrenta/ErroriCodiciFiscaliDichiarazione', { idDichiarazioneDichiarante, idDichiarazioneConiuge, anno });

export const listaDocMancanti = (idDichiarazione, anno) => WebRequest.get('SetteTrenta/ListaDocumentiMancanti', { idDichiarazione, anno });

export const listaPdfImportabili730 = () => WebRequest.get('SetteTrenta/ListaPdfImportabili730', {});
// #endregion

// #region Post actions

export const elimina = (idDichiarazione, anno) => WebRequest.post('SetteTrenta/Elimina', {}, { idDichiarazione, anno });

export const annullaElimina = (idDichiarazione, anno) => WebRequest.post('SetteTrenta/AnnullaElimina', {}, { idDichiarazione, anno });

export const impostaStatoCompleta = (idDichiarazione, anno) => WebRequest.post('SetteTrenta/ImpostaStatoCompleta', {}, { idDichiarazione, anno });

export const impostaStatoDaControllare = (idDichiarazione, anno) => WebRequest.post('SetteTrenta/ImpostaStatoDaControllare', {}, { idDichiarazione, anno });

export const impostaStatoTrasmettiManualmente = (idDichiarazione, anno) => WebRequest.post('SetteTrenta/ImpostaStatoTrasmettiManualmente', {}, { idDichiarazione, anno });

export const impostaStatoInLavorazione = (idDichiarazione, anno) => WebRequest.post('SetteTrenta/ImpostaStatoInLavorazione', {}, { idDichiarazione, anno });

export const impostaStatoAnnullata = (idDichiarazione, anno) => WebRequest.post('SetteTrenta/ImpostaStatoAnnullata', {}, { idDichiarazione, anno });

export const stampeVarie = idDichiarazione => WebRequest.post('SetteTrenta/StampeVarie', {}, { idDichiarazione });

export const stampaUfficiale = idDichiarazione => WebRequest.post('SetteTrenta/StampaUfficiale', {}, { idDichiarazione });

export const stampaF24 = idDichiarazione => WebRequest.post('SetteTrenta/StampaF24', {}, { idDichiarazione });

export const stampaParcelle = idDichiarazione => WebRequest.post('SetteTrenta/StampaParcelle', {}, { idDichiarazione });

export const stampaMassivaDiProva = dichiarazioniIds => WebRequest.post('SetteTrenta/StampaMassivaDiProva', dichiarazioniIds);

export const stampaMassivaVarie = dichiarazioniIds => WebRequest.post('SetteTrenta/StampaMassivaVarie', dichiarazioniIds);

export const stampaMassivaUfficiale = dichiarazioniIds => WebRequest.post('SetteTrenta/StampaMassivaUfficiale', dichiarazioniIds);

export const cambioStatoMassivoInLavorazione = (dichiarazioniIds, anno) => WebRequest.post('SetteTrenta/CambioStatoMassivoInLavorazione', { DichiarazioniIds: dichiarazioniIds, Anno: anno });

export const cambioStatoMassivoAnnulla = (dichiarazioniIds, anno) => WebRequest.post('SetteTrenta/cambioStatoMassivoAnnulla', { DichiarazioniIds: dichiarazioniIds, Anno: anno });

export const cambioStatoMassivoDaInviare = (dichiarazioniIds, anno) => WebRequest.post('SetteTrenta/cambioStatoMassivoDaInviare', { DichiarazioniIds: dichiarazioniIds, Anno: anno });

export const cambioStatoMassivoCompleta = (dichiarazioniIds, anno) => WebRequest.post('SetteTrenta/cambioStatoMassivoCompleta', { DichiarazioniIds: dichiarazioniIds, Anno: anno });

export const protocolloIntegrativaObbligatorio = (codiceFiscale, studio, anno) => WebRequest.post('SetteTrenta/ProtocolloIntegrativoObbligatorio', {}, { codiceFiscale, studio, anno });

export const creaSetteTrentaOrdinaria = (studio, codiceFiscale, nome, cognome, tipo, anno) => WebRequest.post('SetteTrenta/CreaOrdinaria', {
  Studio: studio,
  CodiceFiscale: codiceFiscale,
  Nome: nome,
  Cognome: cognome,
  TipoDichiarazione: tipo,
  Anno: anno,
});

export const creaDaAnnoPrecedente = (studio, codiceFiscale, nome, cognome, tipo, anno, origine) => WebRequest.post('SetteTrenta/CreaDaAnnoPrecedente', {
  Studio: studio,
  CodiceFiscale: codiceFiscale,
  Nome: nome,
  Cognome: cognome,
  TipoDichiarazione: tipo,
  Anno: anno,
  Origine: origine,
});


export const creaSetteTrentaIntegrativa = cmd => WebRequest.post('SetteTrenta/CreaIntegrativo', cmd);

export const creaStampaOld = (
  filtri,
  dichiarazioniIds,
  IsStampaUfficiale,
  StampaDichiarazione,
  AutocertificazioneGenerica,
  FascicoloContribuente,
  AutocertificazioneFamiglieNumerose,
  DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
  InformativaPrivacy,
  AutocertificazioneFamiliari,
  StampaF24,
  Scelta582x1000,
  AutocertificazioneC4,
  RichiestaAccredito,
  DocumentiDaConsegnare,
  AutocertificazioneOneri,
  PromemoriaConguagli,
  DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta
  AutocertificazioneF6,
  CalcoloBonusIRPEF,
  Fatture,
  LetteraNovita,
  Barra2Provvisorio,
  RistampaLeStampate,
  FronteRetro,
  ModelliCompilati,
  GuidaLettura,
  NrCopie,
  // ImpostazioneStampa,
  // MaxPaginePdf,
  // IsStampaUfficiale,
  SalvaPreferenze,
  codiceUfficio,
  anno,
  ArchiviaInZip,
) => WebRequest.post(`SetteTrenta/CreaStampaOld?${filtri}`, {
  DichiarazioniIds: dichiarazioniIds,
  StampaDichiarazione,
  AutocertificazioneGenerica,
  FascicoloContribuente,
  AutocertificazioneFamiglieNumerose,
  DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
  InformativaPrivacy,
  AutocertificazioneFamiliari,
  StampaF24,
  Scelta582x1000,
  AutocertificazioneC4,
  RichiestaAccredito,
  DocumentiDaConsegnare,
  AutocertificazioneOneri,
  PromemoriaConguagli,
  DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta
  AutocertificazioneF6,
  CalcoloBonusIRPEF,
  Fatture,
  LetteraNovita,
  Barra2Provvisorio,
  RistampaLeStampate,
  FronteRetro,
  NrCopie,
  SoloModelliCompilati: ModelliCompilati,
  GuidaLettura,
  SalvaPreferenze,
  // IsStampaUfficiale,
  CodiceUfficio: codiceUfficio,
  Anno: anno,
  ArchiviaInZip,
});

export const creaStampa = (
  filtri,
  dichiarazioniIds,
  IsStampaUfficiale,
  StampaDichiarazione,
  AutocertificazioneGenerica,
  FascicoloContribuente,
  DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
  InformativaPrivacy,
  AutocertificazioneFamiliari,
  StampaF24,
  Scelta582x1000,
  AutocertificazioneC4,
  AutocertificazioneCasiParticolariQuadroC,
  RichiestaAccredito,
  DocumentiDaConsegnare,
  AutocertificazioneOneri,
  PromemoriaConguagli,
  DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta
  AutocertificazioneF6,
  CalcoloBonusIRPEF,
  Fatture,
  LetteraNovita,
  Barra2Provvisorio,
  RistampaLeStampate,
  FronteRetro,
  ModelliCompilati,
  GuidaLettura,
  Ricevuta730AdE,
  NrCopie,
  // ImpostazioneStampa,
  // MaxPaginePdf,
  // IsStampaUfficiale,
  SalvaPreferenze,
  codiceUfficio,
  anno,
  ArchiviaInZip,
) => WebRequest.post(`SetteTrenta/CreaStampa?${filtri}`, {
  DichiarazioniIds: dichiarazioniIds,
  StampaDichiarazione,
  AutocertificazioneGenerica,
  FascicoloContribuente,
  DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
  InformativaPrivacy,
  AutocertificazioneFamiliari,
  StampaF24,
  Scelta582x1000,
  AutocertificazioneC4,
  AutocertificazioneCasiParticolariQuadroC,
  RichiestaAccredito,
  DocumentiDaConsegnare,
  AutocertificazioneOneri,
  PromemoriaConguagli,
  DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta
  AutocertificazioneF6,
  CalcoloBonusIRPEF,
  Fatture,
  LetteraNovita,
  Barra2Provvisorio,
  RistampaLeStampate,
  FronteRetro,
  NrCopie,
  SoloModelliCompilati: ModelliCompilati,
  GuidaLettura,
  Ricevuta730AdE,
  SalvaPreferenze,
  // IsStampaUfficiale,
  CodiceUfficio: codiceUfficio,
  Anno: anno,
  ArchiviaInZip,
});

export const stampaBarra4 = (dichiarazioni) => {
  const { CodiceUfficio, Anno } = dichiarazioni[0] || {};
  return WebRequest.post(
    Anno < 2020 ? 'SetteTrenta/CreaStampaOld' : 'SetteTrenta/CreaStampa', {
      DichiarazioniIds: Anno < 2020 ? dichiarazioni.map(x => x.IdDichiarazione) : dichiarazioni.map(x => ({
        id: x.IdDichiarazione, cf: x.CodiceFiscale, cognome: x.Cognome, nome: x.Nome, origine: x.DatiAddizionali.Origine,
      })),
      StampaDichiarazione: false,
      IsStampaUfficiale: true,
      AutocertificazioneGenerica: false,
      AutocertificazioneFamiliari: false,
      AutocertificazioneFamiglieNumerose: false,
      AutocertificazioneC4: false,
      AutocertificazioneCasiParticolariQuadroC: false,
      AutocertificazioneOneri: false,
      AutocertificazioneF6: false,
      CalcoloBonusIRPEF: false,
      DelegaUnica: false,
      StampaF24: false,
      InformativaPrivacy: false,
      RichiestaAccredito: false,
      PromemoriaConguagli: false,
      RistampaLeStampate: false,
      DocumentiDaConsegnare: false,
      FronteRetro: false,
      SoloModelliCompilati: false,
      GuidaLettura: false,
      NrCopie: 1,
      SalvaPreferenze: false,
      CodiceUfficio,
      Ricevuta7304: true,
      Anno,
    },
  );
};

export const dettaglioBarra4 = (idDichiarazione, anno) => WebRequest.get('SetteTrenta/Dettaglio7304', { idDichiarazione, anno });

export const stampaContribuenti7304 = (baseUrl, anno, codiceUfficio) => {
  window.open(`${baseUrl}?anno=${anno}&ufficio=${codiceUfficio}`);
};

export const modificaAnagraficheDichiarazione = cmd => WebRequest.post('SetteTrenta/ModificaAnagraficheDichiarazione', cmd);

export const totali7304 = (studio, anno, searchTerm) => WebRequest.get('SetteTrenta/Barra4', { studio, anno, searchTerm });

export const datiRiduzioneAcconto = (idDichiarazione, anno) => WebRequest.get('SetteTrenta/DatiRiduzioneAcconto', { idDichiarazione, anno });

export const stampaRiduzioneAcconto = stato => WebRequest.post('SetteTrenta/StampaRiduzioneAcconto', stato);

export const creaDaXmlAnnoCorrente = (file, lista, studio, anno, nomeFile) => WebRequest.post('SetteTrenta/ImportazioneXmlAnnoCorrente', {
  PathFornituraXmlAnnoCorrenteDaImportare: file, listaDichiarazioni: lista, ufficio: studio, Anno: anno, NomeFile: nomeFile,
});

export const creaDaRedditiPFAnnoCorrente = (lista, studio, anno, nomeFile, pathFornituraRedditiPFDaImportare) => WebRequest.post('SetteTrenta/ImportazioneRedditiPFAnnoCorrente', {
  listaDichiarazioni: lista, ufficio: studio, Anno: anno, NomeFile: nomeFile, PathFornituraRedditiPFDaImportare: pathFornituraRedditiPFDaImportare,
});

export const stampaLetteraPrecontrolli = stato => WebRequest.post('SetteTrenta/StampaLetteraPrecontrolli', stato);

export const stampaLetteraDiniego = stato => WebRequest.post('SetteTrenta/StampaLetteraDiniego', stato);

export const modificaSegnalibro = (id, segnalibro) => WebRequest.post('Dichiarazione/ModificaSegnalibro', { IdDichiarazione: id, Segnalibro: segnalibro });

export const creaTabulatoDebitiCrediti = (lista, currentUserId, studio, anno, filtri) => WebRequest.post(`SetteTrenta/TabulatoDebitiCrediti?${filtri}`, {
  ListaDichiarazioni: lista,
  CodiceUfficio: studio,
  Anno: anno,
  CurrentUserId: currentUserId,
  /* public Guid CorrelationId { get; set; } */
});

export const creaTabulatoOneriAnnoPrecedente = (lista, currentUserId, studio, anno, filtri) => WebRequest.post(`SetteTrenta/TabulatoOneriAnnoPrecedente?${filtri}`, {
  ListaDichiarazioni: lista,
  CodiceUfficio: studio,
  Anno: anno,
  CurrentUserId: currentUserId,
  /* public Guid CorrelationId { get; set; } */
});

export const creaTabulatoDettaglioProspettoLiquidazioneQuadroA = (lista, currentUserId, studio, anno, filtri) => WebRequest.post(`SetteTrenta/TabulatoDettaglioProspettoLiquidazioneQuadroA?${filtri}`, {
  ListaDichiarazioni: lista,
  CodiceUfficio: studio,
  Anno: anno,
  CurrentUserId: currentUserId,
  /* public Guid CorrelationId { get; set; } */
});

export const creaTabulatoDettaglioProspettoLiquidazioneQuadroB = (lista, currentUserId, studio, anno, filtri) => WebRequest.post(`SetteTrenta/TabulatoDettaglioProspettoLiquidazioneQuadroB?${filtri}`, {
  ListaDichiarazioni: lista,
  CodiceUfficio: studio,
  Anno: anno,
  CurrentUserId: currentUserId,
  /* public Guid CorrelationId { get; set; } */
});

// #endregion
